import { clone } from '@/utils';
import * as campaign_config from './campaign';

/**
 * 获取计划表单配置
 * @param {string[]} keys 表单字段名称组成的数组
 * @returns {Object}
 */
export const getCampaignConfig = (keys = []) => {
  const config = clone(campaign_config);
  for (const key in config) {
    if (config[key] && !(keys.includes(key))) {
      delete config[key];
    }
  }
  return config;
};
